





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Attribute } from '@/interfaces/Attribute';

@Component({})
export default class AttributesViewAttributeDetailsDialog extends Vue {
  @Prop()
  attribute!: Attribute;

  isTypeKey(value: string) {
    return value === '' || value === 'servercount' || 'Ungültiger Typschlüssel';
  }
}
